import React from "react";
import Blog_50 from "../component/Blog_50";
function Blog_50_container() {
  return <Blog_50 />;
}

export default Blog_50_container;
